import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useHistory, useLocation } from 'quartz-routing/react-router';
import { Paths } from '../../constants/paths';
import { useAppContext } from '../../context/AppContext';
import { useGates } from '../../hooks/useGates';
import { getTemplateMarketplaceUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
function useTabDefinitions() {
  const appContext = useAppContext();
  const lang = getLang();
  const {
    workflowTemplatesPhase2
  } = useGates();
  return [{
    tabId: 'home',
    titleKey: 'marketplaceStorefront.storefrontNav.home',
    href: Paths.HOME,
    isExternal: false
  }, {
    tabId: 'apps',
    titleKey: 'marketplaceStorefront.storefrontNav.apps',
    href: Paths.APPS,
    isExternal: false,
    eventType: 'APP'
  }, {
    tabId: 'agents',
    titleKey: workflowTemplatesPhase2 ? 'marketplaceStorefront.storefrontNav.automation' : 'marketplaceStorefront.storefrontNav.agents',
    href: Paths.AGENTS,
    isExternal: false,
    eventType: 'AGENT'
  }, {
    tabId: 'themes',
    titleKey: 'marketplaceStorefront.storefrontNav.templates',
    href: getTemplateMarketplaceUrl(appContext, lang),
    isExternal: true,
    eventType: 'theme'
  }, {
    tabId: 'solutions',
    titleKey: 'marketplaceStorefront.storefrontNav.solutionsPartners',
    href: Paths.SOLUTIONS_PARTNERS,
    isExternal: false,
    eventType: 'solution provider'
  }];
}
function isTabActive(pathname, tab) {
  if (tab.isExternal) {
    return false;
  }
  if (tab.href === Paths.HOME) {
    return pathname === '/' || pathname === '';
  }
  return pathname === tab.href || pathname.startsWith(`${tab.href}/`);
}
function useActiveTab(tabs) {
  var _tabs$find;
  const {
    pathname
  } = useLocation();
  return (_tabs$find = tabs.find(tab => isTabActive(pathname, tab))) === null || _tabs$find === void 0 ? void 0 : _tabs$find.tabId;
}
export function StorefrontTabNav() {
  const history = useHistory();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const tabs = useTabDefinitions();
  const activeTab = useActiveTab(tabs);
  const handleTabChange = event => {
    const selectedTab = tabs.find(t => t.tabId === event.target.value);
    if (!selectedTab || selectedTab.tabId === activeTab) {
      return;
    }
    if (selectedTab.eventType) {
      trackMarketplaceEvent(getMarketplaceInteractionEvent({
        action: 'storefront nav link clicked',
        type: selectedTab.eventType
      }));
    }
    if (selectedTab.isExternal) {
      window.location.href = selectedTab.href;
    } else {
      history.push(selectedTab.href);
    }
  };
  return /*#__PURE__*/_jsx(Tabs, {
    selected: activeTab,
    onSelectedChange: handleTabChange,
    moreTabsRenderer: null,
    children: tabs.map(tab => /*#__PURE__*/_jsx(Tab, {
      tabId: tab.tabId,
      title: unescapedText(tab.titleKey)
    }, tab.tabId))
  });
}